import { render, staticRenderFns } from "./company_verify.vue?vue&type=template&id=be1c8bfe&"
import script from "./company_verify.vue?vue&type=script&lang=js&"
export * from "./company_verify.vue?vue&type=script&lang=js&"
import style0 from "./company_verify.vue?vue&type=style&index=0&id=be1c8bfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports